import Layout from "../../components/Layout";
import {useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import ApiRoute, {shopId} from "../../helper/api";
import SearchBox from "../../components/SearchBox";
import PagesTable from "../../components/Tables/PagesTable";
import Pagination from "../../components/Pagination";
import CreatePageModal from "../../components/Page/CreatePageModal";
import Modal from "../../components/Utilities/Modal";
import ProductSelect from "../../components/Product/ProductSelect";
import {formatNumberWithDots, getDateAsReadableFormat} from "../../helper/general";
import {MinProductPrice} from "../../components/Order/Create/Step3";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit, faTrash} from "@fortawesome/free-solid-svg-icons";
import {faRemove} from "@fortawesome/free-solid-svg-icons/faRemove";
import CategorySelect2 from "../../components/Product/Category/CategorySelect2";
import BrandSelect2 from "../../components/Product/Category/BrandSelect2";

export default function SnappShop(){
    const navigate = useNavigate()
    const [createModal, setCreateModal] = useState(false)
    const [newData, setNewData] = useState({
        snapp_shop_product_id: '',
        product:{},
        active: true
    })

    const [isLoading, setIsLoading] = useState(true)
    const [updateData, setUpdateData] = useState(0)
    const [pageNumber, setPageNumber] = useState(1)
    const [data, setData] = useState({})
    const [searchQuery, setSearchQuery] = useState({
        term: '',
        by: 'title'
    })
    const [filterQuery, setFilterQuery] = useState({})

    // state tab for filtering
    const [statsTab , setStatsTab] = useState(null)
    const [selectedStatsTab , setSelectedStatsTab] = useState('')

    const [selectedCategory, setSelectedCategory] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState([]);
    const [selectedStock, setSelectedStock] = useState('');
    const [selectedActive, setSelectedActive] = useState('');

    //fetch data from server and update data /| based on updateData state
    useEffect(() => {
        (async () => {
            setIsLoading(true)
            const  res  = await ApiRoute.integrate.snappShop.index.fn({
                shop_id: shopId(),
                page : pageNumber
            },filterQuery)
            setData(res)
            setIsLoading(false)
        })();
    }, [updateData]);

    const paginationData = data?.results
    const tableData = data?.results?.data ?? []

    // watch pageNumber and update updateData state
    useEffect(() => {
        setUpdateData(Date.now().toString())
    }, [pageNumber]);
    // watch searchQuery and update updateData state
    useEffect(() => {
        filterQuery.quick_search = searchQuery
        setUpdateData(Date.now().toString())
    }, [searchQuery]);

    useEffect(() => {
        setUpdateData(Date.now().toString())
    }, [selectedCategory, selectedBrand, selectedStock, selectedActive]);

    const tableTitles = [
        {
            title: 'محصول',
        },
        {
            title: 'شناسه اسنپ',
        },
        {
            title: 'موجودی سایت',
        },
        {
            title: 'وضعیت',
        },
        {
            title: 'ایجاد',
        }
    ]

    async function handleSubmit(){
       const res = await ApiRoute.integrate.snappShop.create.fn(newData)
       if (res?.status_code === 200){
           setCreateModal(false)
           setNewData({
               snapp_shop_product_id: '',
               product:{},
               active: true
           })
           setUpdateData(Date.now())
       }
    }


    const handleMultiSelectCategory = (_selectedCategory) => {
        if (Array.isArray(_selectedCategory)) {
            filterQuery.category = _selectedCategory.map(item => item?.slug).filter(Boolean)
            setSelectedCategory(_selectedCategory);
        }
    }

    const handleMultiSelectBrand = (_selectedBrand) => {
        if (Array.isArray(_selectedBrand)) {
            filterQuery.brand = _selectedBrand.map(item => item?.value).filter(Boolean)
            setSelectedBrand(_selectedBrand);
        }
    }

    const handleStockChange = (value) => {
        filterQuery.stock = value === '' ? '' : value === 'true'
        setSelectedStock(value === '' ? '' : value === 'true')
    }

    const handleActiveChange = (value) => {
        filterQuery.active = value === '' ? '' : value === 'true'
        setSelectedActive(value === '' ? '' : value === 'true')
    }

    return (
        <Layout>
            <div>
                <div className="flex items-center justify-between mb-3">
                    <div className="page-title flex-auto ml-3 md:ml-0">
                        <span className="inline-block bg-white pl-3">محصولات اسنپ شاپ</span>
                    </div>
                    <button onClick={() => setCreateModal(true)} className="btn-blue text-center md:hidden"> افزودن محصول جدید</button>
                </div>

                <div className="grid md:flex justify-between items-center gap-3">
                    <div className="flex gap-3">
                        <SearchBox SearchByOptions={[
                        { label: "کد اسنپ" , value : "snapp_shop_product_id" },
                        { label: "نام محصول" , value : "title" }
                    ]} SearchByDefault={'snapp_shop_product_id'} SetSearchQuery={setSearchQuery} SearchIn={true}/>
                    </div>
                    <button onClick={() => setCreateModal(true)} className="btn-blue text-center hidden md:block">افزودن محصول جدید</button>
                </div>

                <div className="flex gap-3 items-center">
                <div>
                            <label>
                                <span className="block">دسته بندی</span>
                                <CategorySelect2
                                    defaultValue={filterQuery.category || []}
                                    assignItem={handleMultiSelectCategory}
                                    placeholder="انتخاب دسته"
                                />
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="block">برند</span>
                                <BrandSelect2
                                    defaultValue={filterQuery.brand || []}
                                    assignItem={handleMultiSelectBrand}
                                    placeholder="انتخاب برند"
                                />
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="block">موجودی</span>
                                <select
                                    className="input-x"
                                    value={selectedStock === true ? 'true' : selectedStock === false ? 'false' : ''}
                                    onChange={(e) => handleStockChange(e.target.value)}
                                >
                                    <option value="">همه</option>
                                    <option value="true">موجود</option>
                                    <option value="false">ناموجود</option>
                                </select>
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="block">وضعیت</span>
                                <select
                                    className="input-x"
                                    value={selectedActive === true ? 'true' : selectedActive === false ? 'false' : ''}
                                    onChange={(e) => handleActiveChange(e.target.value)}
                                >
                                    <option value="">همه</option>
                                    <option value="true">فعال</option>
                                    <option value="false">غیرفعال</option>
                                </select>
                            </label>
                        </div>
                </div>

                {!isLoading && <div className="main-content p-1 mt-2">

                    <table className="table-auto w-full block mt-4">
                        <thead>
                        <tr className="border-b border-b-gray-7">
                            {tableTitles.map((item, id) => (
                                <td className={` text-13 relative text-gray-6 pb-2`} key={id}>
                                    {item.title}
                                </td>
                            ))}
                            <td></td>
                        </tr>
                        </thead>
                        <tbody>
                        {tableData?.map(tableData => (
                                <tr className={`text-xs py-2`} key={tableData?.id}>

                                    <td>
                                        <a 
                                            href={`/inventory?id=${tableData?.product?.product_id ?? ''}`} 
                                            className="text-blue-500 hover:underline cursor-pointer"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {tableData?.product.title}
                                        </a>
                                    </td>

                                    <td>
                                        <input onInput={ (e) => {
                                            tableData.snapp_shop_product_id = e.target.value
                                        } } className={`input-x`} defaultValue={tableData?.snapp_shop_product_id}/>
                                    </td>

                                    <td>
                                        {tableData?.item?.stocks?.live ?? '-'}
                                    </td>

                                    <td>
                                        <select 
                                            onChange={(e) => {
                                                tableData.active = e.target.value === 'true'
                                            }} 
                                            className={`input-x`} 
                                            defaultValue={tableData?.active !== false ? 'true' : 'false'}
                                        >
                                            <option value="true">فعال</option>
                                            <option value="false">غیرفعال</option>
                                        </select>
                                    </td>

                                    <td>
                                        {getDateAsReadableFormat(tableData?.created_at)}
                                    </td>

                                    <td>
                                        <div className={`flex items-center gap-3 text-[15px]`}>
                                            <button onClick={ async () => {
                                                await ApiRoute.integrate.snappShop.update.fn(tableData._id, {
                                                    ...tableData,
                                                    active: tableData.active !== false
                                                })
                                            } } className={`text-green-1`}>
                                                <FontAwesomeIcon icon={faEdit}/>
                                            </button>
                                            <button onClick={ async () => {
                                                if (!window.confirm('آیا از حذف این محصول اطمینان دارید؟')) {
                                                    return;
                                                }
                                                await ApiRoute.integrate.snappShop.delete.fn(tableData._id)
                                                setUpdateData(Date.now())
                                            } } className={`text-red-1`}>
                                                <FontAwesomeIcon icon={faTrash}/>
                                            </button>
                                        </div>
                                    </td>

                                </tr>
                            )
                        )}
                        </tbody>
                    </table>

                    <Pagination SetPageNumber={setPageNumber} Data={paginationData}/>
                </div>}

            </div>

            {createModal &&  <Modal isOpen={createModal} onClose={() => {
                setCreateModal(false)
            }}>
                <div>

                    <div className="page-title z-1 text-right text-sm">
                        <span className="inline-block bg-white pl-3 pr-1 mb-3 relative z-2">افزودن محصول</span>
                    </div>

                    <div className={`flex gap-2 w-full flex-col`}>

                        <input onInput={ (e) => {
                            newData.snapp_shop_product_id = e.target.value;
                        } } className='input-x' type="text" placeholder="شناسه محصول در اسنپ شاپ ..."/>
                        <ProductSelect allowOutStock={true} fixed={true} assignItem={ (s) => {
                            s.map((item) => {
                                newData.product = {
                                    title:item.title,
                                    _id:item._id,
                                    slug:item.slug,
                                    categories:item.categories,
                                    brand:item.attributes.brands.values[0] || null
                                }
                            })
                        } }/>
                        <button onClick={handleSubmit} className={`btn-green max-w-max rounded`}>افزودن</button>

                    </div>

                </div>
            </Modal>}


        </Layout>
    )
}